module.exports = __webpack_public_path__ + "static/img/iAPS-icon.f93bdefa.png";